<div [class]="alertClass()">
  <span class="notification__content">
    <span class="notification__icon">
      <i [class]="iconClass()"></i>
    </span>
    <span class="notification__message">{{ message() }}</span>
  </span>
</div>
